import { Analytics, LocalGasStation, LocalShipping } from "@mui/icons-material";
import { UserRole } from "../system/Domain";
import LayoutNavigation from "../Components/Layout/LayoutNavigation";
import LayoutNavigationItem from "../Components/Layout/LayoutNavigationItem";
import LayoutNavigationSection from "../Components/Layout/LayoutNavigationSection";
import RootNavigationSection from "./RootNavigationSection";

export default () => {
	return (
		<LayoutNavigation>
			<LayoutNavigationSection title="Dienstleister">
				<LayoutNavigationItem
					roles={[UserRole.AldManager]}
					icon={<Analytics />}
					title="Dienstleister"
					path="/companies"
				/>
				<LayoutNavigationItem
					roles={[UserRole.AldManager]}
					icon={<LocalShipping />}
					title="Frachtpreise"
					path="/companies/transport-prices"
				/>
				<LayoutNavigationItem
					roles={[UserRole.AldManager]}
					icon={<LocalGasStation />}
					title="Dieselzuschlag"
					path="/companies/diesel-surcharge"
				/>
			</LayoutNavigationSection>
			<RootNavigationSection />
		</LayoutNavigation>
	);
};
